// extracted by mini-css-extract-plugin
module.exports = {"newsSlugContent":"newsDetail_newsSlugContent__3ws06"};